//init
import * as Realm from 'realm-web';
const app = new Realm.App({ id: process.env.REACT_APP_MNDB_RELM_TRXN});


export const AuthCodeTrxn = async () => {
  const cred = Realm.Credentials.apiKey(process.env.REACT_APP_MNDB_AUTH_TRXN);
  const user = await app.logIn(cred);
  return user
}

// ------------------------ //
export const CreateEvents = async (item) => {
  const trxnuser = await AuthCodeTrxn()
  const result = await trxnuser.functions.toknCreateEvent(JSON.stringify({
    ...item, 
    webb: process.env.REACT_APP_WEBB_SITE_NMBR
  }));
  // console.log(result)
  return JSON.parse(result);
}

export const GetUserEventsList = async (item) => {
  const trxnuser = await AuthCodeTrxn()
  const result = await trxnuser.functions.toknGetUserEventsList(JSON.stringify({
    ...item, 
    webb: process.env.REACT_APP_WEBB_SITE_NMBR
  }));
  // console.log(result)
  return JSON.parse(result);
}


export const GetEventsList = async (item) => {
  const trxnuser = await AuthCodeTrxn()
  const result = await trxnuser.functions.toknGetEventsList(JSON.stringify({
    ...item, 
    webb: process.env.REACT_APP_WEBB_SITE_NMBR
  }));
  // console.log(result)
  return JSON.parse(result);
}


export const GetEventsCount = async (item) => {
  const trxnuser = await AuthCodeTrxn()
  const result = await trxnuser.functions.toknGetEventsCount(JSON.stringify({
    ...item, 
    webb: process.env.REACT_APP_WEBB_SITE_NMBR
  }));
  // console.log(result)
  return JSON.parse(result);
}


export const GetEventsInfo = async (item) => {
  const trxnuser = await AuthCodeTrxn()
  const result = await trxnuser.functions.toknGetEventsInfo(JSON.stringify({
    ...item, 
    webb: process.env.REACT_APP_WEBB_SITE_NMBR
  }));
  // console.log(result)
  return JSON.parse(result);
}

export const NewTicketSales = async (item) => {
  const trxnuser = await AuthCodeTrxn()
  const result = await trxnuser.functions.toknNewTicketSales(JSON.stringify({
    ...item, 
    webb: process.env.REACT_APP_WEBB_SITE_NMBR
  }));
  // console.log(result)
  return JSON.parse(result);
}